import * as types from "./mtypes";
import axios from "axios";
import { handleRequest } from "@/store/utils/requestFunctions";
import * as endpoints from "@/store/constants/endpoints";

export default {
  async getPermissions({ commit }, params) {
    await handleRequest(
      commit,
      () => axios.get(`${endpoints.PERMISSIONS}${params}`),
      types.FETCH_PERMISSIONS_SUCCESS,
      types.REQUEST_FAILURE,
    );
  },

  async addPermission({ commit }, instance) {
    await handleRequest(
      commit,
      () => axios.post(`${endpoints.PERMISSIONS}`, instance),
      types.REQUEST_SUCCESS,
      types.REQUEST_FAILURE,
    );
  },

  async getApps({ commit }) {
    await handleRequest(
      commit,
      () => axios.get(`${endpoints.PERMISSIONS}/apps`),
      types.FETCH_PERMISSIONS_APPS,
      types.REQUEST_FAILURE,
    );
  },
};
